import { isEqual } from 'lodash'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { ICompanyLastSelectedState } from '~/types/company/models'

const companyLastSelectedStateListData =
  undefined as unknown as ICompanyLastSelectedState[]

export const getCompanyLastSelectedStateListData = getListDataFunctionFactory<
  ICompanyLastSelectedState[]
>({
  listData: companyLastSelectedStateListData,
  storageKey: 'companylastselectedstates',
  getStartingListData: getStartingCompanyLastSelectedStateListData,
})

export async function getCompanyLastSelectedStateData(
  id: TEntityId
): Promise<ICompanyLastSelectedState> {
  const list: ICompanyLastSelectedState[] =
    await getCompanyLastSelectedStateListData()
  if (!list) {
    throw new Error(`getCompanyLastSelectedStateList returned undefined/null`)
  }
  const companyLastSelectedState = list.find((clsd) => clsd.id === id)
  if (!companyLastSelectedState) {
    throw new Error(`Can't find companyLastSelectedState '${id}'`)
  }
  return companyLastSelectedState
}

export async function getCompanyLastSelectedStateDataByCompanyId(
  id: TEntityId
): Promise<ICompanyLastSelectedState | undefined> {
  const list: ICompanyLastSelectedState[] =
    await getCompanyLastSelectedStateListData()
  if (!list) {
    throw new Error(`getCompanyLastSelectedStateList returned undefined/null`)
  }
  const companyLastSelectedState = list.find((clsd) =>
    isEqual(clsd.companyId, id)
  )
  return companyLastSelectedState
}

export async function getStartingCompanyLastSelectedStateListData(): Promise<
  ICompanyLastSelectedState[]
> {
  return []
}
